/* !
 * newsTag.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const thisTag = (FUNCTIONS.va.isEnglish) ? location.pathname.split('/')[4] : location.pathname.split('/')[3];

	const params = new URLSearchParams(location.search);
	const page = params.get('rt_bn_news_list_skip');

	const newParams = new URLSearchParams();
	if (page !== null) {
		newParams.set('rt_bn_news_list_skip', page);
	}
	const newSearch = newParams.toString() ? `?${newParams.toString()}` : '';

	const setNewsList = () => {
		const filetype = [
			'.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx', '.csv', '.tsv', '.txt', '.rtf', '.png',
			'.jpg', '.jpeg', '.gif', '.webp', '.svg', '.bmp', '.tif', '.tiff', '.zip', '.7z', '.rar', '.tar', '.gz', '.bz2',
			'.mp3', '.wav', '.m4a', '.aac', '.flac', '.mp4', '.mov', '.m4v', '.avi', '.wmv', '.webm'
		];

		const jsonURL = `/ajax${(FUNCTIONS.va.isEnglish) ? '/english' : ''}/news/tag/${thisTag}/list.json${newSearch}`;
		console.log(jsonURL);

		fetch(jsonURL).then(response => response.json()).then(data => {
			if (data.rt_bn_news_list.length) {

				Vue.createApp({
					data() {
						return {
							jsonData: data.rt_bn_news_list,
							count: 20
						}
					},
					methods: {
						setBr(content) {
							return content.replace(/\r?\n/g, '<br>');
						},
						setAttachment(item) {
							if (item.rt_cf_n_href.class && item.rt_cf_n_href.class === 'rt_cf_nolink') {
								return 'nolink';
							} else if (item.rt_cf_n_href.href.endsWith('.pdf')) {
								return 'pdf';
							} else if (FUNCTIONS.va.newsFileType.some(type => item.rt_cf_n_href.href.endsWith(type))) {
								return 'file';
							} else if (item.rt_cf_n_type3_ext_link_is !== null) {
								return 'blank';
							} else {
								return 'link';
							}
						},
						setTarget(att) {
							if (att === 'link') {
								return '_self';
							} else {
								return '_blank';
							}
						},
						setFilesize(bytes) {
							let sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
							if (bytes === 0) {
								return 'n/a';
							}
							let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
							if (i === 0) {
								return bytes + sizes[i];
							}
							return (bytes / Math.pow(1024, i)).toFixed(1) + sizes[i];
						}
					},
					computed: {
						filterItems() {
							let items = this.jsonData;
							let itemsTemp = []

							// 最新では20件
							if (location.pathname.endsWith('/news/') || location.pathname.endsWith('/news/index.html')) {
								for (let i = 0; i < this.count; i++) {
									itemsTemp.push(items[i]);
								}
								items = itemsTemp;
							}

							return (items);
						}
					}
				}).mount('#vue-app');
			}
		});
	};

	// ＝＝＝＝ ↑↑ FUNCTIONS ↑↑ ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝

	const newsTagFUNCTIONS = () => {
		setNewsList();
	};

	(FUNCTIONS.localDecision()) ? document.addEventListener('localincludeLoaded', () => { newsTagFUNCTIONS(); }) : newsTagFUNCTIONS();

})(window.FUNCTIONS);
